import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Register() {
    const [form, setForm] = useState({
        company_name: "", name: "", email: "", password: "", phone: "",
    });
    const [loading, setLoading] = useState(false);
    const { register, error } = useAuth();
    const navigate = useNavigate();

    const update = (k, v) => setForm((f) => ({ ...f, [k]: v }));

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const ok = await register(form);
        setLoading(false);
        if (ok) {
            toast.success("登録しました");
            navigate("/dashboard");
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center p-6 bg-[var(--prc-bg)]" data-testid="register-page">
            <form onSubmit={submit} className="w-full max-w-lg prc-card p-8">
                <p className="prc-label-overline mb-2">新規登録</p>
                <h1 className="text-[1.685rem] font-bold tracking-tight">企業アカウントを作成</h1>
                <p className="mt-2 text-sm text-[var(--prc-muted)]">
                    既にアカウントをお持ちの方は <Link to="/login" className="font-semibold underline" data-testid="register-goto-login">ログイン</Link>
                </p>

                <div className="mt-6 grid grid-cols-1 gap-4">
                    <div>
                        <label className="prc-label-overline block mb-1.5">会社名</label>
                        <input required className="prc-input" value={form.company_name} onChange={(e) => update("company_name", e.target.value)} data-testid="register-company-input" />
                    </div>
                    <div className="grid grid-cols-2 gap-3">
                        <div>
                            <label className="prc-label-overline block mb-1.5">担当者名</label>
                            <input required className="prc-input" value={form.name} onChange={(e) => update("name", e.target.value)} data-testid="register-name-input" />
                        </div>
                        <div>
                            <label className="prc-label-overline block mb-1.5">電話番号</label>
                            <input className="prc-input" value={form.phone} onChange={(e) => update("phone", e.target.value)} data-testid="register-phone-input" />
                        </div>
                    </div>
                    <div>
                        <label className="prc-label-overline block mb-1.5">メールアドレス</label>
                        <input type="email" required className="prc-input" value={form.email} onChange={(e) => update("email", e.target.value)} data-testid="register-email-input" />
                    </div>
                    <div>
                        <label className="prc-label-overline block mb-1.5">パスワード（6文字以上）</label>
                        <input type="password" required minLength={6} className="prc-input" value={form.password} onChange={(e) => update("password", e.target.value)} data-testid="register-password-input" />
                    </div>
                </div>

                {error && <p className="mt-4 text-sm text-[var(--prc-red)]" data-testid="register-error">{error}</p>}

                <button disabled={loading} type="submit" className="prc-btn-primary w-full mt-6" data-testid="register-submit-btn">
                    {loading ? "登録中…" : "アカウント作成（Starter プラン）"}
                </button>
                <p className="mt-3 text-xs text-[var(--prc-muted)]">登録後、Starter プラン（最大50台）が自動適用されます。いつでもアップグレード可能です。</p>
            </form>
        </div>
    );
}
